module.exports = __webpack_public_path__ + "img/semantic-methods.990a5886.png";